module.exports = __webpack_public_path__ + "static/media/mastercard_logo.3a6d8b9d.png";